
export const skillsInfo = [
    {
        name: 'TypeScript',
        color: '#2D79C7'
    },
    {
        name: 'JavaScript',
        color: '#E4A125'
    },
    {
        name: 'Java',
        color: '#c7161a'
    },
    {
        name: 'React',
        color: '#169aab'
    },
    {
        name: 'React Native',
        color: '#077ea9'
    },
    {
        name: 'Python',
        color: '#3878AA'
    },
    {
        name: 'Kotlin',
        color: '#E1725C'
    },
    {
        name: 'Jetpack Compose',
        color: '#3570B4'
    },
    {
        name: 'Swift',
        color: '#FD7734'
    },
    {
        name: 'SwiftUI',
        color: '#0072FD'
    },
    {
        name: 'Vue',
        color: '#3FB984'
    },
    {
        name: 'Next.js',
        color: '#5e5e5e'
    },
    {
        name: 'Node.js',
        color: '#93C745'
    },
    {
        name: 'AWS',
        color: '#FF9C08'
    },
    {
        name: 'GCP',
        color: '#EB493D'
    },
    {
        name: 'Go',
        color: '#1EAED8'
    },
    {
        name: 'HTML',
        color: '#E5532C'
    },
    {
        name: 'CSS',
        color: '#2465F1'
    },
    {
        name: 'Ruby',
        color: '#AD0C00'
    },
    {
        name: 'Ruby on Rails',
        color: '#CD0000'
    },
    {
        name: 'Django',
        color: '#2BA977'
    },
    {
        name: 'Spring Boot',
        color: '#6db33f'
    },
    {
        name: 'SQL',
        color: '#DC7939'
    },
    {
        name: 'MongoDB',
        color: '#4FAA41'
    },
];